export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_locationNo') || '库位编码',
    field: 'locationNo',
    width: 160,
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_locationFullName') || '库位全称',
    field: 'locationFullName',
    minWidth: 160,
    fixed: 'left',
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.stock_form_location_desc') || '库位说明',
    field: 'locationDescription',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_locType') || '库位类型',
    field: 'locType',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_locSellType') || '库位售卖类型',
    field: 'locSellType',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_is_last') || '是否末级',
    field: 'v_isLast',
    width: 80,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    slots: { default: 'isLast' },
  },
  {
    title: that.$l('table_label_locationStatus') || '有效状态',
    field: 'locationStatus',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    slots: { default: 'locationStatus' },
  },
  {
    title: that.$l('table_label_warehouseDescription') || '所属库房',
    field: 'warehouseDescription',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
